import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';

const IsvFixedFeeAmountField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return (
		<FullInfoField label="isvFixedFeeAmountLabel" value={restaurantForFullInfo?.vivaWalletIsv?.isvFixedFeeAmount} />
	);
};

export default IsvFixedFeeAmountField;
